import script from "./ParticipatingCustomersWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./ParticipatingCustomersWidget.vue?vue&type=script&setup=true&lang=js"

import "./ParticipatingCustomersWidget.vue?vue&type=style&index=0&id=4173bffb&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4173bffb"]])

export default __exports__